// extracted by mini-css-extract-plugin
export var inputContainer = "_qr-0";